import Column from 'ALIASED-antd/lib/table/Column';
import Link from 'ALIASED-antd/lib/typography/Link';
import { useForm, useWatch } from 'ALIASED-antd/lib/form/Form';
import { Comment } from '@ant-design/compatible';
import { PageHeader } from '@ant-design/pro-components';

import { Form } from 'ALIASED-antd';
import { StyledAntModal as Modal } from '../src/components/StyledAntModal/StyledAntModal';

export { Form };
export { AsyncAntdButton as Button } from '../src/components/AsyncComponents';
export { WrappedAntdSelect as Select } from '../src/components/WrappedAntdSelect/WrappedAntdSelect';
export { WrappedAntdCascader as Cascader } from '../src/components/WrappedAntdCascader/WrappedAntdCascader';
export { TimeAdjustedDatePicker as DatePicker } from '../src/components/DatePicker/DatePicker';
export { Comment };
export { PageHeader };
export { Column };
export { Link };
export { Modal };
export {
  Alert,
  ConfigProvider,
  Divider,
  Input,
  Radio,
  Space,
  Spin,
  Row,
  Col,
  Table,
  Tooltip,
  Card,
  Empty,
  Descriptions,
  Dropdown,
  Avatar,
  Menu,
  Checkbox,
  List,
  Typography,
  AutoComplete,
  InputNumber,
  Carousel,
  Result,
  Upload,
  Collapse,
  Switch,
  Skeleton,
  Grid,
  TimePicker,
  Timeline,
  Image,
  Steps,
  Tabs,
  Layout,
  Progress,
  Badge,
  notification,
  Tag,
  Rate,
  Drawer,
  Popover,
  theme,
  Affix,
  Statistic,
  Breadcrumb,
  ColorPicker,
  Popconfirm,
  Segmented,
  Slider,
  Tree,
  TreeSelect,
  message,
  version,
  unstableSetRender
} from 'ALIASED-antd';

const useFormInstance = Form.useFormInstance;

export { useForm, useFormInstance, useWatch };

export type {
  FormProps,
  FormItemProps,
  AlertProps,
  ButtonProps,
  CardProps,
  MenuProps,
  InputRef,
  FormInstance,
  ModalFuncProps,
  ModalProps,
  ResultProps,
  TableProps,
  TableColumnType,
  InputProps,
  UploadFile,
  SelectProps,
  RadioChangeEvent
} from 'ALIASED-antd';

export type { SorterResult, ColumnsType } from 'ALIASED-antd/lib/table/interface';
export type { TabsProps } from 'ALIASED-antd/lib/tabs';
export type { RcFile } from 'ALIASED-antd/lib/upload/interface';
export type { Rule, RuleObject } from 'ALIASED-antd/lib/form';
export type { RangePickerProps } from 'ALIASED-antd/lib/date-picker';
export { FormProvider } from 'ALIASED-antd/lib/form/context';

export type { FilterValue } from 'ALIASED-antd/lib/table/interface';
export type { CheckboxChangeEvent } from 'ALIASED-antd/lib/checkbox';
